import React from 'react';
import PropTypes from 'prop-types';
import EditModal from './EditModal/EditModalView';
import {
  Wrapper,
  AddButton,
  EditButton,
  ExecutiveSummaryTitle,
  ExecutiveSummaryMessage,
} from './ExecutiveSummaryStyles';
import Icon from '../CommonComponents/Icon';

const ExecutiveSummaryView = ({
  currentClient,
  executiveSummaryMessage,
  errors,
  isSavingExecutiveSummary,
  isEditExecutiveSummaryModalOpen,
  openEditExecutiveSummaryModal,
  closeEditExecutiveSummaryModal,
  saveExecutiveSummary,
  deleteExecutiveSummary,
  isDeletingExecutiveSummary,
  setErrors,
  isAdviserArea,
  showExecutiveSummary,
}) => {
  if (!showExecutiveSummary) {
    return null;
  }

  return (
    (isAdviserArea || !!executiveSummaryMessage) && (
      <Wrapper>
        {executiveSummaryMessage ? (
          <>
            <ExecutiveSummaryTitle>Executive Summary</ExecutiveSummaryTitle>
            <ExecutiveSummaryMessage>{executiveSummaryMessage}</ExecutiveSummaryMessage>
            {isAdviserArea && (
              <EditButton onClick={openEditExecutiveSummaryModal}>
                <Icon className="far fa-edit" />
              </EditButton>
            )}
          </>
        ) : (
          isAdviserArea && (
            <AddButton prependIcon="fas fa-plus-circle" onClick={openEditExecutiveSummaryModal}>
              Add An Executive Summary
            </AddButton>
          )
        )}

        {isEditExecutiveSummaryModalOpen && (
          <EditModal
            errors={errors}
            setErrors={setErrors}
            isOpen={isEditExecutiveSummaryModalOpen}
            isSaving={isSavingExecutiveSummary}
            isDeleting={isDeletingExecutiveSummary}
            executiveSummaryMessage={executiveSummaryMessage}
            onClose={closeEditExecutiveSummaryModal}
            onSave={message => saveExecutiveSummary(currentClient.Id, message)}
            onDelete={() => deleteExecutiveSummary(currentClient.Id)}
          />
        )}
      </Wrapper>
    )
  );
};

ExecutiveSummaryView.defaultProps = {
  executiveSummaryMessage: '',
};

ExecutiveSummaryView.propTypes = {
  currentClient: PropTypes.shape().isRequired,
  executiveSummaryMessage: PropTypes.string,
  errors: PropTypes.arrayOf(PropTypes.string).isRequired,
  isSavingExecutiveSummary: PropTypes.bool.isRequired,
  isEditExecutiveSummaryModalOpen: PropTypes.bool.isRequired,
  openEditExecutiveSummaryModal: PropTypes.func.isRequired,
  closeEditExecutiveSummaryModal: PropTypes.func.isRequired,
  saveExecutiveSummary: PropTypes.func.isRequired,
  deleteExecutiveSummary: PropTypes.func.isRequired,
  isDeletingExecutiveSummary: PropTypes.bool.isRequired,
  setErrors: PropTypes.func.isRequired,
  isAdviserArea: PropTypes.bool.isRequired,
  showExecutiveSummary: PropTypes.bool.isRequired,
};

export default ExecutiveSummaryView;
